import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, PaginatedEventTypeList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompleteEventType {
  search?: string;
}

function useAutoCompleteEventType({
  search,
}: IUseAutoCompleteEventType): UseQueryResult<AxiosResponse<PaginatedEventTypeList>> {
  const fetchAutoCompleteEventType = (): Promise<AxiosResponse<PaginatedEventTypeList>> => {
    const params: UrlParams = { limit: '100', offset: '0' };

    if (search) {
      params.search = search;
    }

    return client.get(`event-types/?${encodeUrlParams(params)}`);
  };

  return useQuery(['eventTypes', search], fetchAutoCompleteEventType);
}

export default useAutoCompleteEventType;
